import cookie from 'cookie';

export const state = () => ({
  isLayoutReady: false
});

export const mutations = {
  setIsLayoutReady(state, layoutReady) {
    state.isLayoutReady = layoutReady;
  }
};

export const getters = {
  isLayoutReady: state => state.isLayoutReady
};

export const actions = {
  async nuxtServerInit({ commit, dispatch, rootState }, { req, $bugsnag }) {
    if (process.server && req?.headers) {
      const h = req.headers;
      const state = h['cf-region-code'];
      if (state) {
        commit('location/setLocation', {
          state,
          fullState: h['cf-region'],
          city: h['cf-ipcity'],
          country: h['cf-ipcountry'],
          zip: h['cf-postal-code']
        });
      }

      const cookies = req.headers.cookie
        ? cookie.parse(req.headers.cookie)
        : {};

      if (cookies['trav:ls'] && !cookies['trav:ssid']) {
        dispatch('auth/logout');
        return;
      }

      // Fetch user data and permission when logged in && currentUser is not set
      if (
        cookies['trav:ls'] &&
        !Object.keys(rootState.auth.currentUser).length
      ) {
        try {
          await dispatch('auth/fetchUser');
          await dispatch('auth/checkUserPermissions');
        } catch (error) {
          $bugsnag?.notify(error);
          console.error('nuxtServerInit error:', error);
        }
      }
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
